import { GraphSchema } from '@camelot/server';

import { CalendarEntry, calendarEntryProps } from './calendar-entry';
import { UnavailabilityType } from './unavailability-type';

export interface CalendarUnavailability extends CalendarEntry {
  type: UnavailabilityType;
  userId: string;
}

const props: (keyof CalendarUnavailability)[] = ['userId'];

export const calendarUnavailabilityProps = new GraphSchema<CalendarUnavailability>(props.concat(calendarEntryProps));
